import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { distinctUntilChanged, Subject, take, takeUntil } from 'rxjs';
import { MailTypeIds, MailTypes } from 'src/app/core/constants/mail-box-const';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { PaginationConfigService } from 'src/app/core/services/paginationconfig.service';
import { PopUpService } from 'src/app/core/services/pop-up/pop-up.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';

@Component({
  selector: 'app-move-mails',
  templateUrl: './move-mails.component.html',
  styleUrls: ['./move-mails.component.scss']
})
export class MoveMailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isAdminMailBox: boolean = false;
  @Input() selectedDomain: any = null;
  @Input() isAdmin: boolean = false;
  @Output() scrollTop: EventEmitter<boolean> = new EventEmitter()
  MailTypeIds = MailTypeIds
  MailTypes = MailTypes
  moreFilterForm: FormGroup = new FormGroup({});
  _unsubscribeAll: Subject<any> = new Subject();

  pagination_config: PaginationType = {
    size: 10,
    total: 0,
    skip: 0,
    limit: 10,
  };
  mailRuleList: any = new MatTableDataSource<any>();
  isEdit: boolean = false;
  mailRuleId: string = '';
  showLoader: boolean = false;
  recipientMailList: any = [];

  constructor(private _fb: FormBuilder, private _popUpService: PopUpService, private _toasterService: ToasterService, private _localStorageService: LocalStorageService, private _mailBoxSerive: MailBoxService, private _loaderService: LoaderService, private datePipe: DatePipe, private _paginationConfigService: PaginationConfigService) {
    this.moreFilterForm = this._fb.group({
      fromMail: [[]],
      subject: [''],
      moveTo: ['', Validators.required],
      name: ['', Validators.required],
      fromName: [],
      isAdmin: [false],
      tenantId: ['', Validators.required],
      receiptMailId: ['', Validators.required],
      existingMails: [false, Validators.required],
      isRead: [false, Validators.required],
      startDate: [''],
      endDate: [''],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDomain']?.currentValue) {

      //setTimeout(() => {
      this.resetForm();
      const userDetails = this._localStorageService.getUser();
      this.recipientMailList = userDetails?.inboxMail.filter((email) => {
        return email?.externalEmailAccess === "true" || email?.isPersonal === "true"
      })
      const { mail } = changes['selectedDomain']?.currentValue;
      const { name, roles } = userDetails;
      this.moreFilterForm.patchValue({
        receiptMailId: mail,
        name: name,
        existingMails: false,
        isRead: false,
        tenantId: roles[0]?.tenant?.join(','),
      });
      //}, 400)
    }
  }

  ngOnInit(): void {
    this._paginationConfigService.pageSize$.pipe(take(1)).subscribe((newSize: number) => {
      this.pagination_config.size = newSize;
      this.pagination_config.limit = newSize;
      setTimeout(() => {
        this.getAddedRule();
      }, 400)
    });
    // this.getAddedRule();
    // this.moreFilterForm.updateValueAndValidity();
    this.moreFilterForm.get('existingMails').valueChanges.pipe(distinctUntilChanged()).subscribe({
      next: (res) => {
        if (res) {
          this.moreFilterForm.get('startDate').setValidators([Validators.required]);
          this.moreFilterForm.get('endDate').setValidators([Validators.required]);
          this.moreFilterForm.updateValueAndValidity();
        } else {
          this.moreFilterForm.get('startDate').clearValidators();
          this.moreFilterForm.get('startDate').updateValueAndValidity();

          this.moreFilterForm.get('endDate').clearValidators();
          this.moreFilterForm.get('endDate').updateValueAndValidity();
        }
      }
    })
  }

  converUnixtoDate(timeStamp: string) {
    const unixTimestamp = Number(timeStamp); // Example Unix timestamp
    const date = new Date(unixTimestamp * 1000); // Convert seconds to milliseconds   
    return date;
  }

  getAddedRule() {
    this.showLoader = true;
    this._mailBoxSerive.getMailRule(this.pagination_config).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (res) => {
        if (res?.statusCode === 200 && res?.success && res?.data) {
          this.showLoader = false;
          this.pagination_config.total = res?.data?.total;
          const convertedData = res?.data?.data?.filter((item) => item?.status == 'true').map((item) => {
            return {
              ...item,
              startDate: item?.startDate ? this.converUnixtoDate(item?.startDate) : '',
              endDate: item?.endDate ? this.converUnixtoDate(item?.endDate) : '',
              moveTo: Number(item?.moveTo),
              fromMail: item?.fromMail.split(',')?.map((item) => item)?.join(', '),
              moveToName: this.MailTypes.find(
                (element) => element.id === Number(item?.moveTo)
              )?.type
            }

          });

          this.mailRuleList = new MatTableDataSource(convertedData);
        } else {
          this.mailRuleList = new MatTableDataSource([]);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  get formControls(): AbstractControl | any {
    return this.moreFilterForm.controls
  }

  public confirmApply(): void {
    if (!this.formControls.fromMail.value && !this.formControls.subject.value) {
      this._toasterService.showError('Error', 'Please fill in at least one field: "From" or "Subject".');
      return
    }

    if (!this.formControls.moveTo.value) {
      this._toasterService.showError('Error', 'Please select where you want to move mails.');
      return
    }
    if (this.moreFilterForm.invalid) {
      this._toasterService.showError('Error', 'Please have all required feilds.');
      return
    }

    this._popUpService.showConfirmationPopup(
      'Are you sure?',
      'You want to move those mail?',
      'Yes',
      (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.applyMoveMails();
        }
      },
      false,
      'No'
    );
  }

  // resetForm() {
  //   Object.keys(this.moreFilterForm.controls).forEach(key => {
  //     this.moreFilterForm.get(key)?.setValue('');
  //   });
  // }

  resetForm() {
    this.moreFilterForm.patchValue({
      fromMail: [],
      subject: '',
      moveTo: '',
      fromName: '',
      existingMails: false,
      isRead: false,
      isAdmin: false,
      startDate: '',
      endDate: ''
    });
    if (this.isAdmin) {
      this.moreFilterForm.patchValue({
        receiptMailId: '',
      });
    }
    this.moreFilterForm.updateValueAndValidity();
  }

  converToUnix(date: any) {
    const formattedDate = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss'); // Format date
    const dateObject = new Date(formattedDate || '');
    const unixTime = Math.floor(dateObject.getTime() / 1000); // Convert to Unix timestamp (seconds)
    return unixTime
  }

  applyMoveMails() {
    let payload = this.moreFilterForm.getRawValue();
    const { fromMail, startDate, endDate, moveTo, ...rest } = payload;
    payload = {
      fromMail: fromMail?.join(','),
      moveTo: moveTo.toString(),
      startDate: startDate && this.formControls.existingMails.value ? this.converToUnix(startDate) : '',
      endDate: endDate && this.formControls.existingMails.value ? this.converToUnix(endDate) : '',
      ...rest
    }
    this._loaderService.showLoader();
    if (this.isEdit) {
      this._mailBoxSerive.updateMailRule(payload, this.mailRuleId).pipe(takeUntil(this._unsubscribeAll)).subscribe({
        next: (res) => {
          this._loaderService.hideLoader();
          if (res?.statusCode === 200 && res?.success) {
            this.isEdit = false;
            this.resetForm();
            this.getAddedRule();
          }
        },
        error: (error: HttpErrorResponse) => {
          this._loaderService.showLoader();
          console.log(error)
        }
      })

    } else {
      this._mailBoxSerive.addMailRule(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe({
        next: (res) => {
          this._loaderService.hideLoader();
          if (res?.statusCode === 200 && res?.success) {
            this.resetForm();
            this.getAddedRule();
          }
        },
        error: (error: HttpErrorResponse) => {
          this._loaderService.showLoader();
          console.log(error)
        }
      })
    }
  }

  editRule(event) {
    this.mailRuleId = event?.id;
    this.scrollTop.emit(true);
    this.moreFilterForm.patchValue({
      receiptMailId: event?.receiptMailId,
      name: event?.name,
      existingMails: event?.existingMails == 'true' ? true : false,
      isRead: event?.isRead == 'true' ? true : false,
      tenantId: event?.tenantId,
      fromMail: event?.fromMail?.split(','),
      subject: event?.subject,
      moveTo: Number(event?.moveTo),
      fromName: event?.fromName,
      startDate: event?.startDate,
      endDate: event?.endDate,
    });
    this.moreFilterForm.updateValueAndValidity();
    this.isEdit = true;
  }

  deleteRule(event) {
    this._popUpService.showConfirmationPopup(
      'Are you sure?',
      'You want to remove this email rule??',
      'Yes',
      (isConfirmed: boolean) => {
        if (isConfirmed) {
          this.applyRemoveMails(event);
        }
      },
      false,
      'No'
    );
  }
  applyRemoveMails(event) {
    this._loaderService.showLoader();
    const { status, ...rest } = event
    const payload = {
      status: 'false',
      ...rest
    }
    this._mailBoxSerive.updateMailRule(payload, event?.id).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (res) => {
        this._loaderService.hideLoader();
        if (res?.statusCode === 200 && res?.success) {
          this.isEdit = false;
          this.resetForm();
          this.getAddedRule();
        }
      },
      error: (error: HttpErrorResponse) => {
        this._loaderService.showLoader();
        console.log(error)
      }
    })
  }


  pagination(event: any) {
    this.pagination_config = {
      ...this.pagination_config,
      skip: event.pageIndex * event.pageSize,
      limit: event.pageSize
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
